class BabyHeightFull extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.coefficients = {
      boy: {
        24: [0, 2.045, 0, 0], 30: [0, 1.942, 0, 0], 36: [0, 1.859, 0, 0], 42: [0, 1.783, 0, 0],
        48: [-10.2567, 1.23812, -0.087235, 0.50286], 54: [-10.719, 1.15964, -0.074454, 0.52887],
        60: [-11.0213, 1.10674, -0.064778, 0.53919], 66: [-11.1556, 1.0748, -0.05776, 0.53691],
        72: [-11.1138, 1.05923, -0.052947, 0.52513], 78: [-11.0221, 1.05542, -0.049892, 0.50692],
        84: [-10.9984, 1.05877, -0.048144, 0.48538], 90: [-11.0214, 1.06467, -0.047256, 0.46361],
        96: [-11.0696, 1.06853, -0.046778, 0.44469], 102: [-11.122, 1.06572, -0.046261, 0.43171],
        108: [-11.1571, 1.05166, -0.045254, 0.42776], 114: [-11.1405, 1.02174, -0.043311, 0.43593],
        120: [-11.038, 0.97135, -0.039981, 0.45932], 126: [-10.8286, 0.89589, -0.034814, 0.50101],
        132: [-10.4917, 0.81239, -0.02905, 0.54781], 138: [-10.0065, 0.74134, -0.024167, 0.58409],
        144: [-9.3522, 0.68325, -0.020076, 0.60927],
      },
      girl: {
        24: [0, 1.917, 0, 0], 30: [0, 1.815, 0, 0], 36: [0, 1.735, 0, 0], 42: [0, 1.677, 0, 0],
        48: [-8.1325, 1.24768, -0.19435, 0.44774], 54: [-6.47656, 1.22177, -0.18519, 0.41381],
        60: [-5.13583, 1.19932, -0.1753, 0.38467], 66: [-4.13791, 1.1788, -0.16484, 0.36039],
        72: [-3.51039, 1.15866, -0.154, 0.3105], 78: [-3.14322, 1.13737, -0.14294, 0.32672],
        84: [-2.87645, 1.11342, -0.13184, 0.31748], 90: [-2.66291, 1.08525, -0.12086, 0.3134],
        96: [-2.45559, 1.05135, -0.11019, 0.31457], 102: [-2.20728, 1.01018, -0.09999, 0.32105],
        108: [-1.87098, 0.9602, -0.09044, 0.33291], 114: [-1.0633, 0.89989, -0.08171, 0.35025],
        120: [0.33468, 0.82771, -0.07397, 0.37312], 126: [1.97366, 0.74213, -0.06739, 0.40161],
        132: [3.50436, 0.67173, -0.06136, 0.42042], 138: [4.57747, 0.6415, -0.05518, 0.41686],
        144: [4.84365, 0.64452, -0.04894, 0.3949],
      },
    };
    this.form = this.querySelector('[data-height-form]');
    this.result = this.querySelector('[data-height-result]');
    this.error = this.querySelector('[data-height-error]');
    this.currentPrediction = null;
    if (!this.form || !this.result) return;
    this.units = this.querySelector('[data-height-units]');
    this.units.addEventListener('change', () => this.updateUnits(true));
    this.form.addEventListener('submit', (event) => this.predict(event));
    this.querySelector('[data-height-recalculate]')?.addEventListener('click', () => this.recalculate());
    this.updateUnits(false);
  }

  toInches(feet, inches) {
    return Number(feet || 0) * 12 + Number(inches || 0);
  }

  setImperialHeight(feetInput, inchesInput, totalInches) {
    if (!Number.isFinite(totalInches) || totalInches <= 0) return;
    const totalTenths = Math.round(totalInches * 10);
    const feet = Math.floor(totalTenths / 120);
    const remainingTenths = totalTenths % 120;
    feetInput.value = String(feet);
    inchesInput.value = (remainingTenths / 10).toFixed(1).replace(/\.0$/, '');
  }

  updateUnits(convertValues) {
    const units = this.units.value;
    const imperialPanel = this.querySelector('[data-height-panel="imperial"]');
    const metricPanel = this.querySelector('[data-height-panel="metric"]');
    if (convertValues) this.convertValues(units);
    imperialPanel.hidden = units !== 'imperial';
    metricPanel.hidden = units !== 'metric';
    imperialPanel.querySelectorAll('input').forEach((input) => { input.disabled = units !== 'imperial'; });
    metricPanel.querySelectorAll('input').forEach((input) => { input.disabled = units !== 'metric'; });
    this.error.hidden = true;
    if (convertValues && this.currentPrediction && !this.result.hidden) this.renderResult();
  }

  convertValues(targetUnits) {
    const fields = this.form.elements;
    if (targetUnits === 'metric') {
      const child = this.toInches(fields.childFeet.value, fields.childInches.value);
      const mother = this.toInches(fields.motherFeet.value, fields.motherInches.value);
      const father = this.toInches(fields.fatherFeet.value, fields.fatherInches.value);
      if (child) fields.childHeightCm.value = (child * 2.54).toFixed(1);
      if (mother) fields.motherHeightCm.value = (mother * 2.54).toFixed(1);
      if (father) fields.fatherHeightCm.value = (father * 2.54).toFixed(1);
      if (Number(fields.childWeightLb.value)) fields.childWeightKg.value = (Number(fields.childWeightLb.value) / 2.2046226218).toFixed(1);
    } else {
      this.setImperialHeight(fields.childFeet, fields.childInches, Number(fields.childHeightCm.value) / 2.54);
      this.setImperialHeight(fields.motherFeet, fields.motherInches, Number(fields.motherHeightCm.value) / 2.54);
      this.setImperialHeight(fields.fatherFeet, fields.fatherInches, Number(fields.fatherHeightCm.value) / 2.54);
      if (Number(fields.childWeightKg.value)) fields.childWeightLb.value = (Number(fields.childWeightKg.value) * 2.2046226218).toFixed(1);
    }
  }

  getMeasurements() {
    const fields = this.form.elements;
    if (this.units.value === 'metric') {
      return {
        childHeight: Number(fields.childHeightCm.value) / 2.54,
        childWeight: Number(fields.childWeightKg.value) * 2.2046226218,
        motherHeight: Number(fields.motherHeightCm.value) / 2.54,
        fatherHeight: Number(fields.fatherHeightCm.value) / 2.54,
      };
    }
    return {
      childHeight: this.toInches(fields.childFeet.value, fields.childInches.value),
      childWeight: Number(fields.childWeightLb.value),
      motherHeight: this.toInches(fields.motherFeet.value, fields.motherInches.value),
      fatherHeight: this.toInches(fields.fatherFeet.value, fields.fatherInches.value),
    };
  }

  formatImperial(inches) {
    const totalTenths = Math.round(inches * 10);
    const feet = Math.floor(totalTenths / 120);
    const remaining = ((totalTenths % 120) / 10).toFixed(1).replace(/\.0$/, '');
    return `${feet} ft ${remaining} in`;
  }

  formatMetric(inches) {
    return `${(inches * 2.54).toFixed(1)} cm`;
  }

  formatHeight(inches, units) {
    return units === 'metric' ? this.formatMetric(inches) : this.formatImperial(inches);
  }

  renderResult() {
    if (!this.currentPrediction) return;
    const { prediction, age, sex } = this.currentPrediction;
    const low = prediction - 4;
    const high = prediction + 4;
    const displayUnits = this.units.value;
    this.querySelector('[data-height-primary]').textContent = this.formatHeight(prediction, displayUnits);
    this.querySelector('[data-height-secondary]').textContent = this.formatHeight(prediction, displayUnits === 'metric' ? 'imperial' : 'metric');
    this.querySelector('[data-height-age-summary]').textContent = `Based on a ${age}-year-old ${sex}'s current height, weight and family height pattern.`;
    this.querySelector('[data-height-low]').textContent = this.formatHeight(low, displayUnits);
    this.querySelector('[data-height-mid]').textContent = this.formatHeight(prediction, displayUnits);
    this.querySelector('[data-height-high]').textContent = this.formatHeight(high, displayUnits);
    this.querySelector('[data-height-range-note]').textContent = displayUnits === 'metric'
      ? 'Likely range (prediction +/- 10.2 cm)'
      : 'Likely range (prediction +/- 4 inches)';
  }

  predict(event) {
    event.preventDefault();
    this.error.hidden = true;
    if (!this.form.reportValidity()) return;
    const sex = this.form.elements.sex.value;
    const age = Number(this.form.elements.age.value);
    const ageMonths = Math.round(age * 12);
    const coefficient = this.coefficients[sex]?.[ageMonths];
    const measurements = this.getMeasurements();
    const valid = coefficient
      && measurements.childHeight >= 50 / 2.54 && measurements.childHeight <= 200 / 2.54
      && measurements.childWeight >= 4 * 2.2046226218 && measurements.childWeight <= 180 * 2.2046226218
      && measurements.motherHeight >= 120 / 2.54 && measurements.motherHeight <= 230 / 2.54
      && measurements.fatherHeight >= 120 / 2.54 && measurements.fatherHeight <= 230 / 2.54;
    if (!valid) {
      this.error.textContent = 'Enter valid current measurements and heights for both parents.';
      this.error.hidden = false;
      return;
    }

    const parentAverage = (measurements.motherHeight + measurements.fatherHeight) / 2;
    const prediction = coefficient[0]
      + coefficient[1] * measurements.childHeight
      + coefficient[2] * measurements.childWeight
      + coefficient[3] * parentAverage;
    this.currentPrediction = { prediction, age, sex };
    this.renderResult();
    this.result.hidden = false;
    this.result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
  }

  recalculate() {
    this.result.hidden = true;
    this.form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    this.form.elements.age.focus({ preventScroll: true });
  }
}

if (!customElements.get('baby-height-full')) {
  customElements.define('baby-height-full', BabyHeightFull);
}
